import React, { useContext, useEffect } from "react";
import Login from '../../Login/Login';
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';
import usuarioLogo from '../../../assets/img/usuario.svg';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { MyContext } from '../../../context/MyContext';
import { Card, CardContent, Typography, CardHeader, Box, Grid, Divider } from '@mui/material';
import { useState } from 'react';
import { identificacaoUsuarioLogado, identificacaoRazaoSocialUsuarioLogado, identificacaoNomeUsuarioLogado, identificaoEnderecoEntrega } from './../../../utils';
import { useHistory } from "react-router-dom";


export default function () {
    const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente
    //const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState(""); // Armazena Criptografado o Nome do Usuário Logado
    const {nomeUsuarioLogado, setNomeUsuarioLogado} = useContext(MyContext);
    const [nomeFullRazaoSocialLogado, setNomeFullRazaoSocialLogado] = useState("");
    const [tipoFrete, setTipoFrete] = useState(-1);
    const history = useHistory();


    useEffect(() => {
        setUsuarioLogado(identificacaoUsuarioLogado());
        setNomeUsuarioLogado(identificacaoNomeUsuarioLogado());
        setNomeFullRazaoSocialLogado(identificacaoRazaoSocialUsuarioLogado());
    }, []);

    const deslogar = async (event) => {
        sessionStorage.removeItem("nome_razao_social_logado");
        sessionStorage.removeItem("nome_usuario_logado");
        sessionStorage.removeItem("id_loja_usuario");
        sessionStorage.removeItem("hash_usuario");
        sessionStorage.removeItem("usuario_compras_faturado");
        sessionStorage.removeItem("jwt");
        setUsuarioLogado("");
        setNomeUsuarioLogado("");
        setTipoFrete(-1);
        history.push("/");
        // PegarEnderecoPadrao();
        // MostrarOpcoesFretes();
        // 02/09/2023  setAtualizarPagina(true); 
    }

    return (
        <>
            <NavBarTop />
            <Grid container justifyContent={"center"} spacing={1} paddingLeft={'10px'}>
                <Grid item xs={12} marginTop={'15px'}>
                    <Typography variant='h6' xs={{ marginBottom: '20px' }}>
                        Deseja Efetuar Logout da Sua Conta?
                    </Typography>
                </Grid>
                <Grid item xs={12} marginTop={'15px'}>
                    <Box
                        display="flex"          // Ativa o Flexbox
                        justifyContent="center" // Centraliza horizontalmente
                        alignItems="center"     // Centraliza verticalmente
                        height="53vh"          // Ocupa a altura total da viewport                        
                    >
                        <Card sx={{ bgcolor: '#F5F5F5', marginRight: '12px', minHeight: '180px', marginBottom: '8px' }}>
                            <CardContent>
                                <Stack spacing={2} direction="row">
                                    <Avatar
                                        src={usuarioLogo}
                                        style={{ borderRadius: 0, height: '32px', width: 'auto' }}
                                    />
                                    <Stack direction="column">
                                        <Typography variant="h5" color="text.primary" textAlign={"left"}>
                                            {nomeFullRazaoSocialLogado.split(' ').slice(0, 2).join(' ')}
                                        </Typography>
                                        <Typography sx={{ fontSize: '9px' }} color="text.primary" textAlign={"left"}>
                                            {nomeUsuarioLogado}
                                        </Typography>
                                        <Divider orientation="horizontal" flexItem sx={{ marginTop: '10px', marginBottom: '10px' }} />

                                        <Stack direction="row" spacing={2} >
                                            <Button
                                                variant="contained"
                                                onClick={(e) =>
                                                    deslogar(e)
                                                }
                                                style={{ backgroundColor: '#357a38', maxWidth: '160px', maxHeight: '25px' }}
                                            >
                                                Efetuar Logoff
                                            </Button>

                                            {/* <a href="#" style={{ fontSize: '14px' }}>Esvaziar Meu Carrinho</a>             */}

                                        </Stack>
                                    </Stack>
                                </Stack>
                            </CardContent>
                        </Card>
                    </Box>
                </Grid>

            </Grid>

            <Rodape />
        </>
    )
}